export default class {
    _id;
    _createdOn;
    _type;
    _account;
    _postIndex;
    _printPackageUid;
    _postPackageUid;
    _perform;
    _transfer;
    _postPackagePostCode;
    _mailSendHistory;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get account() {
        return this._account;
    }

    set account(value) {
        this._account = value;
    }

    get postIndex() {
        return this._postIndex;
    }

    set postIndex(value) {
        this._postIndex = value;
    }

    get printPackageUid() {
        return this._printPackageUid;
    }

    set printPackageUid(value) {
        this._printPackageUid = value;
    }

    get postPackageUid() {
        return this._postPackageUid;
    }

    set postPackageUid(value) {
        this._postPackageUid = value;
    }

    get postPackagePostCode() {
        return this._postPackagePostCode;
    }

    set postPackagePostCode(value) {
        this._postPackagePostCode = value
    }

    get perform() {
        return this._perform;
    }

    set perform(value) {
        this._perform = value;
    }

    get transfer() {
        return this._transfer;
    }

    set transfer(value) {
        this._transfer = value;
    }

    get mailSendHistory() {
        return this._mailSendHistory;
    }

    set mailSendHistory(value) {
        this._mailSendHistory = value;
    }
}
